module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"mobileDesignConfirmationModal\" title=\"Mobile Design\" style=\"display: none;\">\r\n\r\n    <div class=\"row\" style=\"padding: 0 0 10px 15px; width: 100%\">\r\n        <div class=\" col-md-12\" id=\"text1\">\r\n            It looks like Mobile Design has not been turned on for this app yet.\r\n            This will let you customize the app to optimize viewing on tablets and phones.\r\n            Prior to publishing you will need to review the tablet and phone canvases to ensure\r\n            that all objects are placed inside the boundaries.\r\n        </div>\r\n    </div>\r\n    <div class=\"row\" style=\"padding: 0 0 10px 15px; width: 100%\">\r\n        <div class=\" col-md-12\" id=\"text2\">\r\n            Would you like to make this app Mobile?\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n")
  }
  return __output;

}